var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools"},[_c('div',{staticClass:"tools__nav"},[_c('div',{staticClass:"tools__nav__container"},[_vm._t("nav-left")],2),_c('div',{staticClass:"tools__nav__container"},[_vm._t("nav-right")],2)]),_c('div',{staticClass:"tools__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }